module.exports = __webpack_public_path__ + "img/finance_5.192bc0c9.png";